import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
import { desaturate, lighten } from "polished";
import Airport from "@engineering/icons/airport";
import CityStation from "@engineering/icons/city-station";
import TrainStation from "@engineering/icons/train-station";
var IconAirport = /*#__PURE__*/ styled(Airport, {
    target: "e1gwjvoz0"
})("height:1.5rem;width:1.5rem;fill:currentcolor;");
var IconCity = /*#__PURE__*/ styled(CityStation, {
    target: "e1gwjvoz1"
})("height:1.5rem;width:1.5rem;fill:currentcolor;");
var IconRail = /*#__PURE__*/ styled(TrainStation, {
    target: "e1gwjvoz2"
})("height:1.5rem;width:1.5rem;fill:currentcolor;");
var DisplayExpressionWrapper = /*#__PURE__*/ styled("span", {
    target: "e1gwjvoz3"
})("width:1.5rem;grid-row:span 2 / span 2;margin-right:1rem;display:flex;flex-shrink:0;align-items:center;");
var ListWrapperBaseStyle = /*#__PURE__*/ css("position:absolute;top:3.75rem;left:0;z-index:50;max-height:25rem;width:100%;overflow-y:auto;border-radius:0.5rem;border-width:0.125rem;box-shadow:0 4px 6px -1px rgb(0 0 0 / 10%),0 2px 4px -2px rgb(0 0 0 / 10%);");
var ResultsListWrapper = /*#__PURE__*/ styled("ul", {
    target: "e1gwjvoz4"
})(ListWrapperBaseStyle, "  border-color:", function(param) {
    var theme = param.theme;
    return lighten(0.065, desaturate(0.25, theme.color.primaryHighlight));
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";");
var ResultsItemBaseStyle = /*#__PURE__*/ css("padding:0.75rem 1.5rem;display:flex;border-bottom-width:0.0625rem;font-size:1.063rem;font-weight:100;line-height:1.412em;", Theme.mq("lg"), "{font-size:1.125rem;line-height:1.333em;}");
var ResultItem = /*#__PURE__*/ styled("button", {
    target: "e1gwjvoz5"
})(ResultsItemBaseStyle, ";border-bottom-color:", function(param) {
    var theme = param.theme;
    return lighten(0.065, desaturate(0.25, theme.color.primaryHighlight));
}, ";width:100%;cursor:pointer;text-align:left;outline-width:0;background-color:", function(param) {
    var selected = param.selected, theme = param.theme;
    return selected && lighten(0.065, desaturate(0.25, theme.color.primaryHighlight));
}, ";&:hover{background-color:", function(param) {
    var theme = param.theme;
    return lighten(0.065, desaturate(0.25, theme.color.primaryHighlight));
}, ";}");
var NoResultsItemWrapper = /*#__PURE__*/ styled("div", {
    target: "e1gwjvoz6"
})(ListWrapperBaseStyle, "  border-color:", function(param) {
    var theme = param.theme;
    return lighten(0.065, desaturate(0.25, theme.color.primaryHighlight));
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";");
var NoResultsItem = /*#__PURE__*/ styled("p", {
    target: "e1gwjvoz7"
})(ResultsItemBaseStyle, ";border-bottom-color:", function(param) {
    var theme = param.theme;
    return lighten(0.065, desaturate(0.25, theme.color.primaryHighlight));
}, ";");
export { DisplayExpressionWrapper, IconAirport, IconCity, IconRail, ResultsListWrapper, ResultItem, NoResultsItemWrapper, NoResultsItem };
